import 'core-js/es6';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import SizeWatcher from './helpers/size';
import './index.css';

const objects = {};
const element = document.getElementById('seehi_root');
objects.sizeWatcher = new SizeWatcher(element);

ReactDOM.render(
  <App />,
  element
);

export default objects;


// WEBPACK FOOTER //
// ./src/index.js